import { LocalStorageService } from '@shared/tools/local-storage.service';
import { Injectable } from '@angular/core';
import { Observable, of, take } from 'rxjs';
import { THEME } from '@shared/tools/constants';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  constructor(private localStorageService: LocalStorageService) {}

  currentTheme(): Observable<string> {
    return of(this.localStorageService.getItem(THEME) || '');
  }

  getThemes() {
    return of([
      { value: 'sc-theme', label: 'Santa Cruz Theme' },
      { value: 'sunrise', label: 'Nascer do Sol' },
    ]);
  }

  setTheme(newTheme: string) {
    this.currentTheme()
      .pipe(take(1))
      .subscribe(oldTheme => {
        if (oldTheme) {
          this.localStorageService.setItem(THEME, newTheme);
          document.body.classList.remove(oldTheme);
          document.body.classList.add(newTheme);
        }
      });
  }
}
